import type { ReactNode } from "react";

export const SectionLabel = ({
  label,
  pill,
}: {
  label: string;
  pill?: ReactNode;
}) => (
  <div className="push-dd-section-label">
    <span>{label}</span>
    {pill}
    <hr />
  </div>
);
